import React from 'react';
import { Drawer } from '../../../../components';
import FormUserAdmin from '../../../../components/FormUser/FormUserAdmin';
import RowHeaderHelp from '../../../../components/RowHeaderHelp';
import { useStyles } from '../../../../services/material-ui';

const CreateUserAdmin: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <RowHeaderHelp name="Novo Usuário" />
        <FormUserAdmin />
      </main>
    </div>
  );
};

export default CreateUserAdmin;
